export const RADIO_OPTIONS = [
  { label: 'Linked', value: 'linked' },
  { label: 'All', value: 'all' },
];

export const EMPTY_TEXT = {
  linked: 'No goals linked to this critical element yet.',
  all: 'No goals available for the selected entering class year.',
};

export const INITIAL_SORTING = [{ id: 'category', desc: false }];
